import React, { useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CtaCorrienteList.css";
import moment from "moment";

const CtaCorrienteList = ({ fchdes, fchhas, orderBy, order, list, loading }) => {
  const formatter = new Intl.NumberFormat("en-US");

  // useMemo (no useState+useEffect) para que listFiltered/totales se recalculen
  // en el mismo render en que cambia `list`, sin frame intermedio mostrando
  // los datos filtrados del proveedor anterior.
  const { listFiltered, totales } = useMemo(() => {
    let saldoInicial = 0;
    let importe = 0;
    let newListFiltered = list.filter((ctaCorriente) => {
      return (
        new Date(ctaCorriente.fchMov).getTime() >= new Date(fchdes).getTime() &&
        new Date(ctaCorriente.fchMov).getTime() <= new Date(fchhas).getTime()
      );
    });

    switch (orderBy) {
      case "Fecha":
        newListFiltered.sort((a, b) =>
          order === "asc"
            ? a.fchMov.localeCompare(b.fchMov)
            : b.fchMov.localeCompare(a.fchMov)
        );
        break;

      case "Titulo":
        newListFiltered.sort((a, b) =>
          order === "asc"
            ? a.formDescrp.localeCompare(b.formDescrp)
            : b.formDescrp.localeCompare(a.formDescrp)
        );
        break;

      default:
        break;
    }

    list.forEach((ctaCorriente) => {
      const fechaMov = ctaCorriente.fchMov.split("T")[0];
      const fechaDesde = fchdes.split("T")[0];
      const fechaHasta = fchhas.split("T")[0];

      if (fechaMov < fechaDesde) {
        saldoInicial = saldoInicial + ctaCorriente.impNac;
      }

      if (fechaMov >= fechaDesde && fechaMov <= fechaHasta) {
        importe = importe + ctaCorriente.impNac;
      }
    });

    return {
      listFiltered: newListFiltered,
      totales: {
        saldoInicial,
        importe,
        saldoFinal: saldoInicial + importe,
      },
    };
  }, [fchdes, fchhas, orderBy, order, list]);

  return (
    <div className="ctaCorrienteListDiv">
      <div className="listHeader">
        <h4>Fecha</h4>
        <h4>Tipo de Comprobante</h4>
        <h4>N° Comprob</h4>
        <h4>N° Interno</h4>
        <h4>Importe</h4>
      </div>
      {loading ? (
        <div className="ctaCorrienteListLoading">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="listBody">
            {listFiltered.map((ctaCorriente, i) => (
              <div key={i} className="itemList">
                <h5>{moment(ctaCorriente.fchMov).format("DD-MM-YYYY")}</h5>
                <h5 id="listTipoComprobante">{ctaCorriente.formDescrp}</h5>
                <h5>{ctaCorriente.codOri}</h5>
                <h5>{ctaCorriente.nroFor}</h5>
                <h5>${formatter.format(ctaCorriente.impNac)}</h5>
              </div>
            ))}
          </div>
          <div className="totalesDiv">
            <h4 className="subtotalItem" id="subtotalLabel">
              Totales:
            </h4>

            <div className="subtotalItem" id="subtotalSaldoInicial">
              <small>Saldo Inicial:</small>
              <div>${formatter.format(totales.saldoInicial)}</div>
            </div>

            <div className="subtotalItem" id="subtotalImporte">
              <small>Importe:</small>
              <div>${formatter.format(totales.importe)}</div>
            </div>

            <div className="subtotalItem" id="subtotalSaldoFinal">
              <small>Saldo Final:</small>
              <div>${formatter.format(totales.saldoFinal)}</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CtaCorrienteList;